import axios from "axios";

export const fetchCards = async () => {
  const res = await axios.get("/api/cards");
  return res.data;
};

export const updateCard = async (id, payload, method = "PATCH") => {
  // method should be either 'PATCH' or 'PUT' depending on your backend
  const m = (method || "PATCH").toUpperCase() === "PUT" ? "PUT" : "PATCH";
  try {
    const res = await axios({
      url: `/api/cards/${id}`,
      method: m,
      data: payload,
      headers: { "Content-Type": "application/json" }
    });
    return res.data; // updated card returned from backend
  } catch (err) {
    // rethrow so callers can handle/display errors
    throw err;
  }
};

// Create a new card record
export const createCard = async (payload) => {
  // ensure payload is JSON serializable and contains required fields
  try {
    const res = await axios.post('/api/cards', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return res.data; // created card
  } catch (err) {
    // rethrow so callers can display validation errors
    throw err;
  }
};

// Import cards from CSV file. formData should be a FormData with the file appended as formData.append('file', file)
export const importCardsCsv = async (formData) => {
  try {
    const res = await axios.post('/api/cards/import_csv', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data; // { created_count, updated_count, errors, ignored_columns }
  } catch (err) {
    // If backend sent a friendly JSON error, surface that to callers
    if (err && err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
};

// Import cards from the free TCGdex API.
// payload supports: { set_id } OR { set_name } OR { card_id }
export const importCardsTcgdex = async (payload) => {
  try {
    const res = await axios.post('/api/cards/import_tcgdex', payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return res.data;
  } catch (err) {
    if (err && err.response && err.response.data) {
      throw err.response.data;
    }
    throw err;
  }
};



// Fetch TCGdex set list (with series info) for picker UX.
export const fetchTcgdexSets = async () => {
  const res = await axios.get("/api/cards/tcgdex/sets");
  return res.data;
};

// Download CSV template. Caller can create a blob URL from the response to trigger download.
export const downloadCsvTemplate = async () => {
  const res = await axios.get('/api/cards/csv_template', { responseType: 'blob' });
  return res;
};

// Permanently delete a card by id
export const deleteCard = async (id) => {
  try {
    const res = await axios.delete(`/api/cards/${id}`);
    return res.data; // deleted card or status from backend
  } catch (err) {
    // rethrow so callers can handle/display errors
    throw err;
  }
};

// Refresh TCGPlayer price for a card and return updated card
export const refreshTcgplayerPrice = async (id) => {
  try {
    const res = await axios.post(`/api/cards/${id}/refresh_tcgplayer_price`);
    return res.data; // updated card returned from backend (with refreshed price)
  } catch (err) {
    if (err && err.response && err.response.data) {
      // surface friendly backend error (e.g., no mapping exists)
      throw err.response.data;
    }
    throw err;
  }
};

const cardsApi = {
  fetchCards,
  updateCard,
  createCard,
  importCardsCsv,
  importCardsTcgdex,
  downloadCsvTemplate,
  deleteCard,
  refreshTcgplayerPrice
};

export default cardsApi;